// @flow
import type { Stock } from '../types';
import CommonApi from './../commonApi';

const stock = new CommonApi<Stock>('stock', 'Склады');

export default {
  ...stock
};
